import { Observable } from 'rxjs';

export type SgToastType = 'success' | 'info' | 'warning' | 'error' | 'wait';

export type SgToastAction = {
  text: string;
  preventDismiss?: boolean;
} & (
  | {
      callback: () => void;
      href?: never;
      target?: never;
    }
  | {
      callback?: never;
      href: string;
      target?: string;
    }
);

export interface SgToastDismissEvent {
  isSummaryToast?: boolean;
}

export interface SgToastConfig {
  type: SgToastType;
  title?: string;
  description?: string;
  showCloseButton?: boolean;
  action?: SgToastAction;
  preventAutoClose?: boolean;
  containerElement?: HTMLElement;
  panelClass?: string | string[];
  inline?: boolean;
  isSummaryToast?: boolean;
  summaryCount?: number;
  _isExistingToast?: boolean; // Internal flag to identify existing toasts for animation handling
  showProgressBar?: boolean;
}

export interface SgToastEntry {
  id: string;
  config: SgToastConfig;
  ref: SgToastRef;
}

export interface SgToastRef {
  dismiss(): void;
  afterDismissed(): Observable<void>;
  afterOpened(): Observable<void>;
  convertTo(type: SgToastType, config: Partial<SgToastConfig>): void;
  readonly closed: boolean;
}

export const TOAST_DURATION = {
  WARNING_ERROR: 7000,
  SUCCESS_INFO: 3000,
  WITH_ACTION: 10000,
  WAIT: 0, // Wait toasts don't auto-dismiss by default
};
